import { fork,all } from 'redux-saga/effects';
import sesionSaga from '../sesion';
/* import condominoSaga from '../condominio';
import inmuebleSaga from '../inmueble';
import ingresoSaga from '../ingreso';
import egresoSaga from '../egreso';
import documentoSaga from '../documento';  
import usuarioSaga from '../usuario';
import razonSocialSaga from '../razonSocial';
import flujoSaga from '../flujo'; */
import late from '../late';
import news from '../news';
import WorkflowActionsSaga from '../workFlow';
import actionsActionsSaga from '../acciones';
import globalDataActionsSaga from '../globaldata';
import clientActionsSaga from '../client';
import usersActionsSaga from '../users';
import roleActionsSaga from '../role';
import trackingCase from '../trackingCase';
import activityActionsSaga from '../activity';
import historyActionsSaga from '../history';
import carCaseActionsSaga from '../carCase';
import garmentCarActionsSaga from '../garmentCar';
import userDenyActionsSaga from '../userDeny';
import messageActionsSaga from '../message';
import documentsActionsSaga from '../documents';
import payActionsSaga from '../pay';
import reportActionsSaga from '../report';

export default function* rootSaga() {
  yield all([
    fork(sesionSaga),
    /* fork(condominoSaga),
    fork(inmuebleSaga),
    fork(ingresoSaga),
    fork(egresoSaga),
    fork(documentoSaga),
    fork(usuarioSaga),
    fork(razonSocialSaga),
    fork(flujoSaga), */
    fork(late),
    fork(news),

    fork(WorkflowActionsSaga),
    fork(actionsActionsSaga),
    fork(globalDataActionsSaga),
    fork(clientActionsSaga),
    fork(usersActionsSaga),
    fork(roleActionsSaga),
    fork(trackingCase),
    fork(activityActionsSaga),
    fork(historyActionsSaga),
    fork(carCaseActionsSaga),
    fork(garmentCarActionsSaga),
    fork(userDenyActionsSaga),
    fork(messageActionsSaga),
    fork(documentsActionsSaga),
    fork(payActionsSaga),
    fork(reportActionsSaga),
  ]);
}
